if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[type="submit"]');

      if (this.form) {
        const idInput = this.form.querySelector('[name="id"]');
        if (idInput) idInput.disabled = false;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') {
        return;
      }

      if (typeof openTlouPopup === 'function') {
        openTlouPopup();
      }
    }
  });
}